import React, { useState } from 'react';
import { HelpPanel, ExpandableSection } from '@amzn/awsui-components-core';

export const InfoPanel: React.FC = () => {
  const [isHowToUseExpanded, setIsHowToUseExpanded] = useState(true);
  const [isBenefitsExpanded, setIsBenefitsExpanded] = useState(true);

  const handleHowToUseToggle = () => {
    setIsHowToUseExpanded(!isHowToUseExpanded);
  };

  const handleBenefitsToggle = () => {
    setIsBenefitsExpanded(!isBenefitsExpanded);
  };

  return (
    <HelpPanel header={<h2>EA Huddle Key Features</h2>}>
      <p>Accelerate setting up multi-org leadership meetings by resolving attendees and generating meeting request from uploaded template</p>

      <ExpandableSection headerText="How to Use" expanded={isHowToUseExpanded} onChange={handleHowToUseToggle}>
        <h5>
          <strong>[1] Download Sample Template</strong>
        </h5>
        <p>Use our Word template as a starting point (optional)</p>

        <h5>
          <strong>[2] Upload Meeting Template</strong>
        </h5>
        <p>Upload the completed template w/ list of attendee names</p>

        <h5>
          <strong>[3] Review Attendee List</strong>
        </h5>
        <p>Check for non-matches, add/remove attendee, verify required/optional</p>

        <h5>
          <strong>[4] Creating Meeting Draft</strong>
        </h5>
        <p>Verified names will show up in Outlook Online meeting draft</p>

        <h5>
          <strong>[5] Send Email to EAs </strong>
        </h5>
        <p>Trigger email template from EA huddle that can be sent to EAs to check LT schedule</p>

        <h5>
          <strong>[6] Send Final Meeting Invite</strong>
        </h5>
        <p>Meeting draft from [4] will show up on your laptop's Outlook as a starting point for meeting scheduling</p>
      </ExpandableSection>

      <ExpandableSection headerText="Benefits" expanded={isBenefitsExpanded} onChange={handleBenefitsToggle}>
        <h5>
          <strong>🎯 Smart Attendee Resolution</strong>
        </h5>
        <p>Automatically identifies and populates both required and optional attendees from the meeting template.</p>

        <h5>
          <strong>🏢 Cross-Org Coordination</strong>
        </h5>
        <p>Designed for large, senior leadership meetings involving multiple orgs and functions.</p>

        <h5>
          <strong>📧 Automated Communication</strong>
        </h5>
        <p>Drafts availability request emails with one click, reducing back-and-forth.</p>

        <h5>
          <strong>📅 Invite Generation</strong>
        </h5>
        <p>Creates Outlook meeting invites in standardized format with complete details.</p>

        <h5>
          <strong>⏰ Time Savings</strong>
        </h5>
        <p>Eliminates 10–15 minutes of manual work per meeting request.</p>

        <h5>
          <strong>🤖 LLM-Powered Parsing</strong>
        </h5>
        <p>Scans meeting templates using advanced AI to extract all relevant information.</p>
      </ExpandableSection>
    </HelpPanel>
  );
};
